// extracted by mini-css-extract-plugin
export default {"spinner":"style_spinner__f16qJ","spinAnimation":"style_spinAnimation__RFBRo"};